"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviousArrow = exports.NextArrow = exports.CompactButtonsContainer = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _utils = require("../utils");
const PreviousArrow = exports.PreviousArrow = (0, _mui.styled)('div', {
  name: 'CarouselPreviousArrow',
  slot: 'PreviousArrow',
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  height,
  position: paginationPosition,
  size,
  theme
}) => ({
  cursor: 'pointer',
  height: (0, _utils.getNavigationArrowHeight)({
    isMobile: true,
    navigationHeight: height,
    paginationPosition,
    theme
  }),
  left: '0px',
  position: 'absolute',
  textAlign: 'center',
  top: height === '100%' ? 0 : '50%',
  transform: height === '100%' ? 'none' : 'translate(0, -50%)',
  width: (0, _utils.getNavigationArrowWidth)({
    size
  }),
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    transition: theme.transitions.create(['background-color'], {
      duration: theme.transitions.duration.short
    })
  },
  zIndex: 2,
  svg: {
    height: '100%',
    fontSize: (0, _utils.getNavigationArrowFontSize)({
      size
    })
  },
  [theme.breakpoints.up('sm')]: {
    height: (0, _utils.getNavigationArrowHeight)({
      isMobile: false,
      navigationHeight: height,
      paginationPosition,
      theme
    })
  }
}));
const NextArrow = exports.NextArrow = (0, _mui.styled)(PreviousArrow, {
  name: 'CarouselNextArrow',
  slot: 'NextArrow',
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})({
  left: 'unset',
  right: '0px'
});
const CompactButtonsContainer = exports.CompactButtonsContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(3)
}));
